<div class="dialogue-content">
  <div class="mat-dialogue-header border-0 pb-0">
    <h4></h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <mat-dialog-content class="pt-0">
    <div class="d-flex align-items-center justify-content-center flex-column gap-2">
      <img src="../../../../../assets/img/success-img.svg" alt="" class="mb-2 img-fluid">
      <p class="confirm-order">Order Placed Successfully </p>
    </div>
    <div class="d-flex align-items-center justify-content-center text-center mb-3">
      <button class="btn btn-primary" (click)="cancel()">OK</button>
    </div>
  </mat-dialog-content>
</div>